import { ComputedFieldsResolver } from '../helpers/types';
import { isPlainObject, PlainObject, visitObjects } from '../helpers/helpers';

export const addComputedFields = (
  entry: PlainObject,
  computedFields: Record<string, ComputedFieldsResolver> = {}
): void => {
  visitObjects(entry, (object) => {
    Object.entries(object).forEach(([fieldName, value]) => {
      const resolve = computedFields[fieldName];

      if (!resolve) return;

      const items = Array.isArray(value) ? value : [value];

      items.forEach((item) => {
        if (!isPlainObject(item)) return;

        try {
          Object.assign(item, resolve(item, entry));
        } catch (error) {
          console.warn(
            `[live-preview] could not compute fields for ${fieldName}:`,
            error
          );
        }
      });
    });
  });
};
